module.exports = __webpack_public_path__ + "img/matrix_item.36cb2324.png";